import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function useCorrectPath(urlUsed, urlPreferred) {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (location.pathname === urlUsed) {
            navigate(urlPreferred, { replace: true });
        }
    }, [location, navigate, urlPreferred, urlUsed]);
}

export default useCorrectPath;
